<div class="modal-dialog session-status-dialog-container">
	<div class="modal-content" cdktrapfocus goDialogContent [goDialogContentAriaLabelledBy]="dialogTitleId">
		<div class="goreact-modal-body">
			<div class="ficon-spinner ficon-4x ficon-spin"></div>
			<h3 class="message" [translate]="data.message" role="alert" aria-live="polite" [id]="dialogTitleId"></h3>
		</div>
	</div>
</div>
